import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";


function FormModal({ show, setShow }) {
    console.log(show," form modal ",show);
  //  const [show, setShow] = useState(false);
    const openIframeWindow = () => {
        setShow(!show);

    }
    return (
        <>

            <Modal show={show} onHide={openIframeWindow} size="lg" centered>
                <Modal.Header closeButton>
                    <h3 style={{ color: "#000", textAlign: "center" }}>EPLIMO</h3>
                </Modal.Header>

                <Modal.Body style={{ padding: 0, height: "70vh" }}>
                    <iframe
                        src="https://vr.biohackforlifesuccess.com/widget/form/3qCXcsZeUEFO3EcQUfjG"
                        style={{ "width": "100%", "height": "100%", "border": "none", "borderRadius": "3px" }}
                        id="inline-tic4BJkP6Bm4hJUJsDKn"
                        data-layout="{'id':'INLINE'}"
                        data-trigger-type="alwaysShow"
                        data-trigger-value=""
                        data-activation-type="alwaysActivated"
                        data-activation-value=""
                        data-deactivation-type="neverDeactivate"
                        data-deactivation-value=""
                        data-form-name="EPLIMO FUNNEL - Calendar Sign Up"
                        data-height="1860"
                        data-layout-iframe-id="inline-tic4BJkP6Bm4hJUJsDKn"
                        data-form-id="tic4BJkP6Bm4hJUJsDKn"
                        title="EPLIMO FUNNEL - Calendar Sign Up"
                    >
                    </iframe>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FormModal;
